import Timer from './Timer';
import Game from '../../../Game';
import { TimerType } from '../TimerTypes';
import DateHelper from '../../../Utility/DateHelper';
import { TimerActions } from '../../../State/Timer/TimerActions';
import { WorldDataHelper } from '../../../Utility/WorldDataHelper';
import { IGameState } from '../../../State/Game/IGameState';

export default class HarvestTimer extends Timer {
    private maxLevel: number;

    constructor() {
        super();
        this.maxLevel = WorldDataHelper.maxLevel();
    }
    public complete(): void {
        TimerActions.updateTimer({
            timer: TimerType.HARVEST,
            time: null,
        });
        Game.scene.getActiveScene().emit('TransitionCrops');
        this.onComplete();
    }
    public onComplete(): void {}
    public isCompleted(state: IGameState = Game.store.getState()): boolean {
        const startDate: Date = this.getDate(state);

        return startDate === null
            ? true
            : DateHelper.now.getTime() - startDate.getTime() >
                  this.getDuration(state).duration;
    }
    public getDuration(
        state: IGameState = Game.store.getState()
    ): { duration: number; format: string } {
        const atMaxLevel: boolean =
            Game.player.getHighestLevelCompleted(state) >= this.maxLevel;
        const duration: number = state.playerState.settings.cinematicMode
            ? 20000 // 20 Sec if in cinematic mode !!Move this to the constants!!
            : !atMaxLevel
            ? DateHelper.Hour // 1 hour if not finished with all levels
            : DateHelper.Hour * 5; // 5 hours if all levels completed

        const format: string =
            duration <= DateHelper.Hour ? 'mm:ss' : 'h:mm:ss';

        return { duration, format };
    }

    public getDate(state: IGameState = Game.store.getState()): Date {
        return state.playerState.timers.get(TimerType.HARVEST);
    }
}
